import { Capacitor } from '@capacitor/core';
import { useLocalStorage } from '@/composables/useLocalStorage';
import { localePath } from '@/utils/i18nRoutes.js';

export const useLogoutRedirect = router => {
  if (Capacitor.isNativePlatform()) {
    const { getLS } = useLocalStorage();
    const region = getLS('cap.region');
    const lang = region === 'cz' ? 'cs' : region || 'cs';
    router.replace(localePath({ name: 'login', language: lang, defaultLanguage: lang }));
  } else {
    location.href = '/login';
  }
};
